import { PiniaVuePlugin } from 'pinia'
import Vue from 'vue'
import VueSimpleHeadful from 'vue-simple-headful'

import { createApp } from '@/app'
import { createRouter } from '@/app/router'
import { setState } from '@/app-state-utils'
import { initSentry } from '@/common/sentry'

import '@/common/http'
import '@/app/error-handler'

Vue.use(PiniaVuePlugin)
Vue.use(VueSimpleHeadful)

const router = createRouter()
const { app } = createApp(router)
initSentry(router)

if (window.context) {
    setState(window.context)
}

// this assumes App.vue template root element has `id="app"`
app.$mount('#app')
